<template>
  <v-list>
    <v-tooltip right :disabled="!touchScreenDevice">
      <template v-slot:activator="{ on }">
        <v-list-item link @click="$emit('return')" v-on="on">
          <v-list-item-action>
            <img class="vis-icon" src="/img/toolbar/Return.svg" />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("ReturnTooltip") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <span>{{ $t("ReturnTooltip") }}</span>
    </v-tooltip>
    <v-list-item-group v-model="markupMode" @change="changeMarkupMode">
      <v-tooltip right :disabled="!touchScreenDevice">
        <template v-slot:activator="{ on }">
          <v-list-item link value="FreehandDraw" v-on="on">
            <v-list-item-action>
              <img class="vis-icon" src="/img/toolbar/cmdFreehand24.svg" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("FreehandTooltip") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ $t("FreehandTooltip") }}</span>
      </v-tooltip>
      <v-tooltip right :disabled="!touchScreenDevice">
        <template v-slot:activator="{ on }">
          <v-list-item link value="AnchoredText" v-on="on">
            <v-list-item-action>
              <img class="vis-icon" src="/img/toolbar/cmdChangeTextCase24.svg" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("AnchoredTextTooltip") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ $t("AnchoredTextTooltip") }}</span>
      </v-tooltip>
      <v-tooltip right :disabled="!touchScreenDevice">
        <template v-slot:activator="{ on }">
          <v-list-item link value="Erase" v-on="on">
            <v-list-item-action>
              <img class="vis-icon" src="/img/toolbar/cmdErase24.svg" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("EraseTooltip") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <span>{{ $t("EraseTooltip") }}</span>
      </v-tooltip>
    </v-list-item-group>
    <v-tooltip right :disabled="!touchScreenDevice">
      <template v-slot:activator="{ on }">
        <v-list-item link @click="showMarkupViews" v-on="on">
          <v-list-item-action>
            <img class="vis-icon" src="/img/toolbar/cmdMarkUp24.svg" />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("ShowMarkupViewsTooltip") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <span>{{ $t("ShowMarkupViewsTooltip") }}</span>
    </v-tooltip>
  </v-list>
</template>

<script>
import { MarkupMode } from "@com.siemens.plm.web/PLMVisWeb";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    markupMode: undefined,
    previousMode: undefined
  }),
  computed: {
    ...mapState(["touchScreenDevice"]),
    ...mapGetters(["viewerManager", "markupManager"])
  },
  mounted: function() {
    this.markupManager = this.viewerManager.markup;
    this.markupManager.enable = true;
    this.markupManager.mode = MarkupMode.Select;
    this.markupManager.addEventListener("create", event => {
      if (event.markupType === "anchoredHTML") {
        this.markupManager.setAnchoredHTMLOnTop(event.psId, true);
      }
    });
  },
  destroyed: function() {
    if (this.markupMode === "Erase") {
      this.markupManager.removeEventListener("select", this.deleteWhenSelected);
    }
    this.markupMode = undefined;
    this.markupManager.mode = MarkupMode.Select;
    this.markupManager.enable = false;
    this.setSideDrawer(null);
  },
  methods: {
    ...mapMutations(["setSideDrawer"]),
    changeMarkupMode: function(newMode) {
      if (newMode === "FreehandDraw") {
        this.markupManager.mode = MarkupMode.Freehand;
      } else if (newMode === "AnchoredText") {
        this.markupManager.mode = MarkupMode.AnchoredText;
      } else if (newMode === "Erase") {
        this.markupManager.mode = MarkupMode.Select;
        this.markupManager.addEventListener("select", this.deleteWhenSelected);
      } else {
        this.markupManager.mode = MarkupMode.Select;
      }
      if (this.previousMode === "Erase") {
        this.markupManager.removeEventListener("select", this.deleteWhenSelected);
      }
      this.previousMode = newMode;
    },
    showMarkupViews: function() {
      this.setSideDrawer("markupViews");
    },
    deleteWhenSelected: function(event) {
      this.markupManager.deleteMarkup(event.psId);
    }
  }
};
</script>

<style scoped></style>
